import {FC} from 'react';
import {Stack} from '@mui/system';
import {CircularProgress, IconButton, TablePagination, Typography} from '@mui/material';
import {useGetImportsQuery} from '../../../../global/services/imports';
import {useParams} from 'react-router-dom';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import CachedIcon from '@mui/icons-material/Cached';
import TableBody from '@mui/material/TableBody';
import {get} from 'lodash';
import {ContractDataImportsTableRow} from './contract-data-imports-table-row';
import {
  setContractDataImportsTablePage,
  useContractDataImportsTableStore,
} from '../../stores/contract-data-imports-table.store';
import {useDebounce} from '../../../../hooks/useDebounce';
import {ContractsSpinner} from '../contracts-spinner';

export const ContractDataImportsTable: FC = () => {
  const {id} = useParams();
  const {page, rowsPerPage} = useContractDataImportsTableStore();
  const debouncedPage = useDebounce(page, 300);

  const {data, refresh, loading} = useGetImportsQuery({
    page: debouncedPage,
    size: 20,
    taskId: id,
  });
  const imports = get(data, 'content', []);
  const rowOffset = get(data, 'number', page) * get(data, 'numberOfElements', rowsPerPage);
  const firstLoading = loading && !get(data, 'content.length');

  if (firstLoading) return <ContractsSpinner />;

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell width={34} />
            <TableCell align="center">№</TableCell>
            <TableCell align="center">Наименование</TableCell>
            <TableCell align="center">Дата начала</TableCell>
            <TableCell align="center">Дата окончания</TableCell>
            <TableCell align="center">ФИО</TableCell>
            <TableCell align="center">
              <Stack direction="row" gap={1} alignItems="center" justifyContent="center">
                <Typography>Статус</Typography>
                <IconButton onClick={refresh} disabled={loading}>
                  {!loading && <CachedIcon color="success" />}
                  {loading && <CircularProgress size={24} color="primary" />}
                </IconButton>
              </Stack>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {imports.map((item, i) => (
            <ContractDataImportsTableRow key={item.id} index={rowOffset + i + 1} data={item} />
          ))}
        </TableBody>
      </Table>
      <TablePagination
        component="div"
        rowsPerPageOptions={[rowsPerPage]}
        count={get(data, 'totalElements', 0)}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={setContractDataImportsTablePage}
      />
    </TableContainer>
  );
};
